import {
	FormControl,
	Input,
	FormErrorMessage,
	Flex,
	FormLabel,
} from "@chakra-ui/react";
import { forwardRef, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import { FormProvider } from "react-hook-form";
import type { User } from "../../types/user.types";

export type AudioFormHandler = {
	valid: () => Promise<boolean>;
	values: () => Partial<User>;
};

const AudioForm = forwardRef<AudioFormHandler>((_, ref) => {
	const methods = useForm();

	useImperativeHandle(ref, () => ({
		valid: () => {
			return methods.trigger();
		},
		values: () => {
			return methods.getValues() as Partial<User>;
		},
	}));
	return (
		<FormProvider {...methods}>
			<form>
				<Flex gap="18px" direction="column">
					<Flex gap="24px">
						<FormControl isInvalid={!!methods.formState.errors.firstName}>
							<FormLabel>Prénom</FormLabel>
							<Input
								id="firstName"
								placeholder="Prénom"
								{...methods.register("firstName", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.firstName?.message}</>
							</FormErrorMessage>
						</FormControl>
						<FormControl isInvalid={!!methods.formState.errors.lastName}>
							<FormLabel>Nom</FormLabel>
							<Input
								id="lastName"
								placeholder="Nom"
								{...methods.register("lastName", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.lastName?.message}</>
							</FormErrorMessage>
						</FormControl>
					</Flex>
					<FormControl isInvalid={!!methods.formState.errors.email}>
						<FormLabel>Email</FormLabel>

						<Input
							id="email"
							placeholder="Email"
							{...methods.register("email", {
								required: "Ce champ est obligatoire",
							})}
						></Input>
						<FormErrorMessage>
							<>{methods.formState.errors?.email?.message}</>
						</FormErrorMessage>
					</FormControl>
				</Flex>
			</form>
		</FormProvider>
	);
});

export default AudioForm;
